export default "__VITE_ASSET__6f8e86a2__"